'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ImageViewer = require('./ImageViewer.scss');

var _ImageViewer2 = _interopRequireDefault(_ImageViewer);

var _Tooltip = require('../Tooltip');

var _Tooltip2 = _interopRequireDefault(_Tooltip);

var _Trash = require('../Icons/dist/components/Trash3');

var _Trash2 = _interopRequireDefault(_Trash);

var _Replace = require('../Icons/dist/components/Replace');

var _Replace2 = _interopRequireDefault(_Replace);

var _Plus = require('../Icons/dist/components/Plus2');

var _Plus2 = _interopRequireDefault(_Plus);

var _WixComponent2 = require('../BaseComponents/WixComponent');

var _WixComponent3 = _interopRequireDefault(_WixComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ImageViewer = function (_WixComponent) {
  _inherits(ImageViewer, _WixComponent);

  function ImageViewer() {
    _classCallCheck(this, ImageViewer);

    return _possibleConstructorReturn(this, (ImageViewer.__proto__ || Object.getPrototypeOf(ImageViewer)).apply(this, arguments));
  }

  _createClass(ImageViewer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          imageUrl = _props.imageUrl,
          onAddImage = _props.onAddImage,
          onUpdateImage = _props.onUpdateImage,
          onRemoveImage = _props.onRemoveImage,
          width = _props.width,
          height = _props.height;


      var tooltipCommonProps = {
        showDelay: 0,
        hideDelay: 0,
        align: 'center',
        placement: 'top',
        moveBy: { x: 2, y: 0 }
      };

      return _react2.default.createElement(
        'div',
        { className: _ImageViewer2.default.container + ' ' + (imageUrl && _ImageViewer2.default.hasLogo), style: { width: width, height: height }, 'data-hook': 'image-container' },
        _react2.default.createElement(
          'div',
          { 'data-hook': 'add-image', className: _ImageViewer2.default.addLogo, onClick: onAddImage },
          _react2.default.createElement('div', { className: _ImageViewer2.default.dashedBorder }),
          _react2.default.createElement(
            'div',
            { className: _ImageViewer2.default.plusIcon },
            _react2.default.createElement(_Plus2.default, { size: '47px' })
          )
        ),
        !!imageUrl && _react2.default.createElement(
          'div',
          { className: _ImageViewer2.default.changeLogoContainer },
          _react2.default.createElement(
            'div',
            { className: _ImageViewer2.default.imageLayout },
            _react2.default.createElement('img', { 'data-hook': 'image-viewer-image', className: _ImageViewer2.default.image, src: imageUrl })
          ),
          _react2.default.createElement(
            'div',
            { className: _ImageViewer2.default.imageBackground },
            _react2.default.createElement(
              'div',
              { className: _ImageViewer2.default.buttons },
              _react2.default.createElement(
                _Tooltip2.default,
                _extends({ content: 'Replace' }, tooltipCommonProps),
                _react2.default.createElement(
                  'div',
                  { 'data-hook': 'update-image', className: _ImageViewer2.default.button, onClick: onUpdateImage },
                  _react2.default.createElement(_Replace2.default, { size: '1.2em' })
                )
              ),
              _react2.default.createElement(
                _Tooltip2.default,
                _extends({ content: 'Remove' }, tooltipCommonProps),
                _react2.default.createElement(
                  'div',
                  { 'data-hook': 'remove-image', className: _ImageViewer2.default.button, onClick: onRemoveImage },
                  _react2.default.createElement(_Trash2.default, { size: '1.2em' })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return ImageViewer;
}(_WixComponent3.default);

ImageViewer.propTypes = {
  imageUrl: _propTypes2.default.string,
  onAddImage: _propTypes2.default.func,
  onUpdateImage: _propTypes2.default.func,
  onRemoveImage: _propTypes2.default.func,
  width: _propTypes2.default.number,
  height: _propTypes2.default.number
};

exports.default = ImageViewer;